import { Component, Inject, inject, } from "@angular/core";
import { AmplifyUser } from '@aws-amplify/ui';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { ConfigService } from "../../config.service";
import { TUI_IS_MOBILE } from "@taiga-ui/cdk";
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { TUI_COUNTRIES_MASKS } from '@taiga-ui/kit';
import { AuthService } from "src/app/services/auth.service";
import { MatDialog } from '@angular/material/dialog';
import { AWSLambda } from 'src/app/AWSLambda.service';

import { CountriesModalComponent } from '../rates/countries-modal.component';
import { RatesModalComponent } from '../rates/rates-modal.component';
import { Rate, RatesModal } from '../rates/rates.model';
import { getCountryInfo } from '../recharges/recharges.countries';
import { BalanceService } from "../../services/balance.service";
import { EsimService } from "../esim/esim.service";
import { MobileService } from "../mobile/mobile.service";
import { BillingService } from "../billing/billing.service";
import { Router } from "@angular/router";
import { PinPukModalComponent } from "../../components/modals/pinpuk-modal.component";
import { Auth } from "aws-amplify";
import { TransferDetailsModalComponent } from "../../components/modals/transfer-details-modal.component";
import { GlobalDataService } from "../../services/global-data.service";
import { detectEnv } from "src/app/services/Enviroment";
import { TranslateService } from "@ngx-translate/core";

/**
 * Componente principal del panel de usuario autenticado.
 * Gestiona información relacionada con el usuario, incluyendo:
 * - eSIMs
 * - contratos móviles
 * - facturas
 * - transferencias
 * - país y atributos de Cognito
 * También se conecta con múltiples servicios como Lambda, MobileService, EsimService, entre otros.
 */
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ['../esim/esim.component.scss'],
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(
          0,
          0,
          0,
          0.5
        ); /* semi-transparent black background */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999; /* Ensure it's on top of other content */
      }
    `,
  ],
})



export class HomeComponent {

  /** Muestra u oculta el spinner de carga global */
  showSpinner = false;

  /** Referencia global al objeto window */
  window = window;

  /** Controlador de modales */
  dialog = inject(MatDialog);

  /** Servicio para invocar funciones Lambda */
  lambda = inject(AWSLambda);

  callModalOpen = false;
  phoneNumber = ""; // tu número real
  callPhone = "";
  errorPhone = false;
  callRequested = false;

  /** Servicio de balance */
  private balanceSvc = inject(BalanceService);

  /** Entorno actual detectado ('dev', 'prod', etc.) */
  protected currentEnv = detectEnv();

  /** Usuario autenticado de Amplify */
  user!: AmplifyUser;

  /** Atributos de usuario desde Cognito */
  attributes: CognitoUserAttribute[] = [];

  /** Código de país del usuario (custom:country) */
  userCountry: string = '';

  /** Lista de eSIMs asociadas al usuario */
  userEsims: any[] = [];

  /** Primera eSIM seleccionada */
  esim: any;

   /** Primera url para whatsapp */
  whatsappUrl = '';

  /** Contratos móviles del usuario */
  userContracts: any[] = [];

  /** Facturas del usuario */
  userBills: any[] = [];

  /** Contador de registros en las listas */
  filteredCounts = {
    userBills: 0,
    transactions: 0,
  };

  /** Transferencias del usuario */
  transactions: any[] = [];

  /** Permite transferencias gratuitas si aplica */
  allow_free_transfer: boolean = false;

  /** Balance actual del usuario */
  balance!: number;

  /** Moneda del usuario (por defecto EUR) */
  currency: string = `EUR`;

  /** Posición del botón (center o between) */
  btn_position: string = "center";

  /** Controla visibilidad del loader de eSIM */
  esimLoader: boolean = true;

  /** Spinners individuales para secciones móviles, facturas y transferencias */
  showSpinnerMobile: boolean = true;
  showSpinnerBills: boolean = true;
  showSpinnerTransfers: boolean = true;

  /** URLs utilizadas para enlaces externos */
  transfersUrl = "";
  creditsUrl = "";
  transfersAccountURL = `${inject(ConfigService).config.transfersAccountURL}?tracker=${inject(AuthService).getUser().id}`;
  mobileUrl = `${inject(ConfigService).config.mobileUrl}`;

  /** Listas de filtros para las listas */
  filterBillsFields: any[] = [];
  filterTransactionFields: any[] = [];

  /** Servicio de autenticación */
  authService = inject(AuthService);

  constructor(
    private esimService: EsimService,
    private mobileService: MobileService,
    private billingService: BillingService,
    private router: Router,
    private globalDataService: GlobalDataService,
    @Inject(TUI_IS_MOBILE) readonly isMobile: boolean,
    @Inject(TUI_COUNTRIES_MASKS)
    private readonly countriesMasks: Record<TuiCountryIsoCode, string>,
    private translate: TranslateService
  ) {
    this.transfersUrl = this.globalDataService.transfersUrlData;
    this.creditsUrl = this.globalDataService.creditsUrlData;
  }

    async  ngOnInit() {
      try {
        await this.authService.refresh();

        // Obtener usuario actual ANTES de pedir atributos
        this.user = await Auth.currentAuthenticatedUser();

        if (this.user) {
          this.attributes = await Auth.userAttributes(this.user);
        } else {
          console.warn('HomeComponent: Usuario no disponible en ngOnInit');
          // Redirigir a login si no hay usuario
          this.router.navigate(['/onboarding/login']);
        }
      } catch (error) {
        console.error('HomeComponent: Error al cargar usuario:', error);
        // Redirigir a login en caso de error de autenticación
        this.router.navigate(['/onboarding/login']);
      }
  }



  openWhatsapp() {
    const msg = this.translate.instant('HOME.WHATSAPP_MESSAGE');
    const encodedMsg = encodeURIComponent(msg);

    this.whatsappUrl = `https://wa.me/+34621122659?text=${encodedMsg}`;

    window.open(this.whatsappUrl, '_blank');
  }


  openLoan() {
    window.open(
      "https://zendy.lendismart.com/api/public/application-template/483cc45c-5344-404b-9c9e-5f9cd5c6aac5",
      "_blank"
    );
  }

  openCallModal() {
  this.callModalOpen = true;
}

closeCallModal() {
  this.callModalOpen = false;
  this.callPhone = "";
  this.errorPhone = false;
  this.callRequested = false;
}

onlyNumbers() {
  // Permite solo dígitos y un + al inicio
  this.callPhone = this.callPhone.replace(/(?!^\+)[^0-9]/g, '');
}

async sendCallRequest() {
  if (!this.callPhone || this.callPhone.length < 9) {
    this.errorPhone = true;
    return;
  }

  this.errorPhone = false;

    // envio de datos
    const result: any = await this.lambda.getLambdaFunction('lambda', '/user/api', {
      queryStringParameters: {
        phone: localStorage.getItem("PhoneNumber"),
        callme: this.callPhone,
        action: 'contactame',
      },
    });


    if (result.status === 'ok') {
      //this.auth.login(this.onboardingService.username, this.onboardingService.password);
      this.router.navigate(['/onboarding/login'], { replaceUrl: true });
    } else {
       this.errorPhone = true;
    }

  // Aquí puedes hacer la API real
  setTimeout(() => {
    this.callRequested = true;
  }, 500);
}




}


